import builder from '../builder';
import ImageFileJPG from '../../streamline-icons/bold/image-file-jpg-1.svg';

export default builder('ImageFileJPGBold', ImageFileJPG);
